import { useTranslation } from 'react-i18next'

import EmptyIllustration from '../../blocks-renderers/components/EmptyIllustration'

import classes from './ConcordeJourneyLauncherControl.module.scss'

export const ConcordeEmptyJourneyLauncher = () => {
  const { t } = useTranslation()

  return (
    <div className={classes.emptyContainer}>
      <EmptyIllustration className={classes.emptyContainerIcon} hideCount />
      <div className={classes.emptyTextContainer}>
        {t('journeyLauncher.emptyState', 'No Journeys connected yet')}
      </div>
    </div>
  )
}
